// extracted by mini-css-extract-plugin
module.exports = {"root":"FormRecoveryCode_root__kEWOk","description":"FormRecoveryCode_description__Mrafy","button":"FormRecoveryCode_button__mCTnp"};